import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {FormBuilder} from "@angular/forms";
import {Order} from "../../../shared/view-model/store-management/order.type";
import {ApolloQueryObservable} from "apollo-angular";
import {OrdersResult, ProcurementService} from "../../services/procurement-service/procurement.service";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {ActivatedRoute, Router} from "@angular/router";
import {SessionActions} from "../../../shared/actions/session.actions";
import {MessageType} from "../../../shared/redux-store/session";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {UpdateOrderMutationVariables} from '../../../shared/graphql/graphql.types';

@Component({
  selector: 'vb-order-list-view',
  templateUrl: './order-list-view.component.html',
  styleUrls: ['./order-list-view.component.css']
})
export class OrderListViewComponent extends AbstractListView implements OnInit, OnDestroy {

  @ViewChild('datatable')
  datatable: DatatableComponent;

  messages = {
    emptyMessage: 'Keine Bestellungen vorhanden',
    totalMessage: 'Bestellungen insgesamt'
  };

  orders$: ApolloQueryObservable<OrdersResult>;
  orders: Order[];

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute,
              private procurementService: ProcurementService,
              sessionActions: SessionActions, cd: ChangeDetectorRef) {

    super(sessionActions, cd);
  }

  onOrderRemoveClicked(order: Order) {
    this.procurementService.deleteOrder(order.cuid).toPromise()
      .then(res => this.sessionActions.pushMessage("Bestellung erfolgreich gelöscht", MessageType.SUCCESS))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen der Bestellung!"));
  }

  ngOnInit() {

    this.isLoading = true;
    this.searchTerm = this.fb.control(null);

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

    this.columns = [
      {prop: 'order_date', name: 'Datum', cellTemplate: this.datatable.formatDateTmpl, minWidth: 50, flexGrow: 1},
      {prop: 'commission_number', name: 'Kommissionsnr.', minWidth: 100, flexGrow: 2},
      {prop: 'supplier.label', name: 'Lieferant', minWidth: 100, flexGrow: 2},
      {prop: 'contact_person', name: 'Bestellt durch', minWidth: 100, flexGrow: 2},
    ];

    this.orders$ = this.procurementService.fetchOrders();
    this.dataSubscriptions.push(this.orders$.subscribe(res => {
        this.isLoading = res.loading;
        this.orders = res.data.orders;
        this.rows = this.orders;
      })
    );

  }

  onCellUpdate(row, res, index) {
  }

  onShowDetailsClicked(order: Order) {
    this.router.navigate([order.cuid], {relativeTo: this.route});
  }

  onMouseOverDetail(order: Order) {
    this.procurementService.prefetchOrder(order.cuid);
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.orders;
    } else {
      if (this.orders) {
        this.rows = this.orders.filter((si: Order) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/order-list-view/order-list-view.component.ts